import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import {
    Card,
    CardContent,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
} from "../components/ui/card";
import { Alert, AlertDescription } from "../components/ui/alert";

export default function NotFound() {
    const location = useLocation();
    const navigate = useNavigate();

    // Extract the attempted page name from the pathname
    const attemptedPath =
        location.pathname.replace(/^\//, "").split("/")[0] || "unknown";

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 p-4">
            <Card className="w-full max-w-md">
                <CardHeader className="text-center">
                    <CardTitle className="text-6xl font-bold text-gray-300 dark:text-gray-600">
                        404
                    </CardTitle>
                    <CardDescription className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mt-4">
                        Page Not Found
                    </CardDescription>
                </CardHeader>
                <CardContent className="space-y-4">
                    <p className="text-center text-gray-600 dark:text-gray-400">
                        The page "
                        <span className="font-mono font-semibold text-gray-900 dark:text-gray-100">
                            {attemptedPath}
                        </span>
                        " could not be found in this application.
                    </p>

                    <Alert>
                        <AlertDescription>
                            <strong>Admin Note</strong>
                            <p className="mt-2 text-sm">
                                This could mean that the AI hasn't implemented
                                this page yet. Ask it to implement it in the
                                chat.
                            </p>
                        </AlertDescription>
                    </Alert>
                </CardContent>
                <CardFooter className="flex justify-center">
                    <Button onClick={() => navigate("/")} className="w-full">
                        Go to Home Page
                    </Button>
                </CardFooter>
            </Card>
        </div>
    );
}
